<template>
  <SoWidget
    :loading="healthChecks.isFetching && !healthChecks.data"
    data-testid="health-checks-widget"
    no-padding
  >
    <SoTabs divider>
      <SoTab title="To Resolve">
        <HealthCheckList
          :health-checks="healthChecks.data"
          filter="failed"
          data-testid="health-checks-widget-list"
        />
      </SoTab>
      <SoTab title="All Other Checks">
        <HealthCheckList
          :health-checks="healthChecks.data"
          filter="passed"
          data-testid="health-checks-widget-list"
        />
      </SoTab>
    </SoTabs>
  </SoWidget>
</template>
<script lang="ts">
  import { defineComponent } from "vue"
  import SoWidget from "@/components/SoWidget.vue"
  import SoTabs from "@/components/tabs/SoTabs.vue"
  import SoTab from "@/components/tabs/SoTab.vue"
  import { mapState } from "pinia"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import HealthCheckList from "@/views/customer/overview/components/HealthCheckList.vue"
  import TrackingService from "@/services/TrackingService"
  export default defineComponent({
    components: {
      SoWidget,
      SoTabs,
      SoTab,
      HealthCheckList,
    },
    computed: {
      ...mapState(useCurrentAccountStore, ["healthChecks"]),
    },
    watch: {
      "healthChecks.data": function () {
        if (!this.healthChecks.isStale && this.healthChecks.isFetched) {
          const status = this.healthChecks.status
          TrackingService.sendEvent(`HealthCheckWidget:load:${status}`)
        }
      },
    },
  })
</script>
